import { render, staticRenderFns } from "./geneDetails.vue?vue&type=template&id=6c632bc6&"
import script from "./geneDetails.vue?vue&type=script&lang=js&"
export * from "./geneDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports